export default "/assets/Icon/moonpay.png"